import { Component, OnInit } from '@angular/core';
import * as globals from '../../../settings';
import {SubscriptionsService} from '../../../_services/subscriptions.service';

@Component({
  selector: 'app-payments',
  templateUrl: './payments.component.html',
  styleUrls: ['./payments.component.scss', './payments.mobile.component.scss']
})
export class PaymentsComponent implements OnInit {
  brand = globals.brand;
  constructor(public subscriptionsService: SubscriptionsService) { }

  ngOnInit() {
  }

}
